
import { Component, Vue } from 'vue-property-decorator'
import CreateProject from "@/components/Project/CreateProject.vue"
import ConfirmDialog from "@/components/ConfirmDialog.vue"
import Tracking from "@/components/Tracking/DashboardTracking.vue"
import ProjectTable from "@/components/Project/ProjectTable.vue"
import CollaboratorInvitation from "@/components/Collaborator/CollaboratorInvitation.vue"
import SnackbarMessage from "@/components/SnackbarMessage.vue"
import CollaborationDisabledHandler from "@/components/Collaborator/CollaborationDisabledHandler.vue"
import CollaborationDeleteHandler from "@/components/Collaborator/CollaborationDeleteHandler.vue"

@Component({
  components: {
    SnackbarMessage,
    CollaboratorInvitation,
    CollaborationDisabledHandler,
    CollaborationDeleteHandler,
    ProjectTable,
    Tracking,
    ConfirmDialog,
    CreateProject
  }
})
export default class Dashboard extends Vue {}
